import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { useEffect, useCallback } from 'react';
import { CalendarGrid } from '@/components/calendar/calendar-grid';
import { useWorkspaceStore } from '@/stores/workspace-store';

const calendarSearchSchema = z.object({
  view: z.enum(['month', 'week']).optional().default('month'),
});

export const Route = createFileRoute(
  '/_authenticated/workspace/$workspaceId/calendar'
)({
  component: CalendarPage,
  validateSearch: calendarSearchSchema,
});

function CalendarPage() {
  const { workspaceId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();
  const { setActiveWorkspace } = useWorkspaceStore();

  useEffect(() => {
    if (workspaceId) setActiveWorkspace(workspaceId);
  }, [workspaceId, setActiveWorkspace]);

  const handleViewChange = useCallback(
    (view: 'month' | 'week') => {
      navigate({ to: '.', search: { view } });
    },
    [navigate]
  );

  const view = search.view || 'month';

  return (
    <div className="flex h-full flex-col space-y-4">
      <h1 className="text-xl font-bold tracking-tight">Calendar</h1>
      <CalendarGrid
        workspaceId={workspaceId}
        view={view}
        onViewChange={handleViewChange}
      />
    </div>
  );
}
